import React from "react";
import PGFacilitiesPage from "./PGFacilitiesPage";

const images = [
  {
    src: "/PG_images/electronics/Arduino.jpg",
    title: "Arduino",
    alt: "Arduino development board",
  },
  {
    src: "/PG_images/electronics/ARM.jpg",
    title: "ARM Board",
    alt: "ARM development board",
  },
  {
    src: "/PG_images/electronics/Dev_Board.jpg",
    title: "Development Board",
    alt: "Development board",
  },
  {
    src: "/PG_images/electronics/eZsdp.jpg",
    title: "eZsdp Board",
    alt: "eZsdp development board",
  },
  {
    src: "/PG_images/electronics/Raspberry_Pi_3.jpg",
    title: "Raspberry Pi 3",
    alt: "Raspberry Pi 3 board",
  },
  {
    src: "/PG_images/electronics/Spartan.jpg",
    title: "Spartan Board",
    alt: "Spartan FPGA board",
  },
  {
    src: "/PG_images/electronics/Spartan_3E.jpg",
    title: "Spartan 3E",
    alt: "Spartan 3E FPGA board",
  },
  {
    src: "/PG_images/electronics/Stellaris.jpg",
    title: "Stellaris Board",
    alt: "Stellaris development board",
  },
];

const facilities = [
  "Arduino development boards",
  "ARM development boards",
  "Embedded development boards",
  "eZsdp development board",
  "Raspberry Pi 3 platforms",
  "Spartan FPGA boards",
  "Spartan 3E FPGA board",
  "Stellaris development board",
];

const facts = [
  ["Programme", "M.Tech. Industrial Electronics"],
  ["Facility Type", "Industrial Electronics Laboratory"],
  ["Equipment Gallery", `${images.length} resources`],
  ["Department", "Electronics and Communication Engineering"],
];

const IndustrialElectronicsFacilities = () => (
  <PGFacilitiesPage
    title="Industrial Electronics Facilities"
    shortTitle="Industrial Electronics"
    programmePath="/programme/industrial-electronics"
    programmeLabel="Industrial Electronics"
    heroImage="/PG_images/electronics/Stellaris.jpg"
    images={images}
    facilities={facilities}
    facts={facts}
  />
);

export default IndustrialElectronicsFacilities;
